import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pana.png'
import _imports_1 from '@/assets/pana1.png'


const _withScopeId = n => (_pushScopeId("data-v-7979e0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "launch d-flex flex-column vh-100 w-100 position-fixed" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "launch-hp" }, "withHalal everyone can scale", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "launch-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "pana",
    class: "w-100"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "launch-para" }, " We'll send you occasional emails with details of money-saving offers and information about our products launch, as well as financial tips to help you make the most of your money. ", -1))
const _hoisted_5 = { class: "launch-form" }
const _hoisted_6 = { class: "launch-h2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center launch-sp" }, " Our vision is to help anyone develop a savings habit and easily access finance timely as need arise without interest regardless of social-economic status. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "launch-img",
  style: {"width":"50rem","padding-top":"6.5rem","padding-bottom":"9.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "pana",
    class: "w-100"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center launch-sp",
  style: {"margin":"4rem 0"}
}, " Please check your email for our welcome message and look out for our emails and SMS as we also unveil our products in coming days. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.alert)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["alert launch-alert", _ctx.error ? 'alert-danger' : 'alert-success']),
          role: "alert"
        }, _toDisplayString(_ctx.message), 3))
      : _createCommentVNode("", true),
    _createVNode(_component_logo),
    _hoisted_2,
    (!_ctx.success)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEmail && _ctx.saveEmail(...args)), ["prevent"])),
              class: _normalizeClass(_ctx.formClass)
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Fullname",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.name]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Input your email to stay tuned about launch",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "launch-input form-control",
                placeholder: "Phone Number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event))
              }, null, 512), [
                [_vModelText, _ctx.phone]
              ]),
              _createVNode(_component_Button, {
                name: _ctx.loading ? 'loading...' : 'subscribe',
                type: "blue",
                disabled: _ctx.loading
              }, null, 8, ["name", "disabled"])
            ], 34)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("h2", _hoisted_6, " Hello! " + _toDisplayString(_ctx.name.split(" ")[0]) + ", welcome to the family ", 1),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ], 64))
  ]))
}